"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CONFIG_LOAD = exports.CONFIG_LOAD = "CONFIG_LOAD";
var CONFIG_LOADED = exports.CONFIG_LOADED = "CONFIG_LOADED";
var CONFIG_ROOT_FOUND = exports.CONFIG_ROOT_FOUND = "CONFIG_ROOT_FOUND";
var CONFIG_PACKAGE_FOUND = exports.CONFIG_PACKAGE_FOUND = "CONFIG_PACKAGE_DIR_FOUND";
var CONFIG_VERSION = exports.CONFIG_VERSION = "CONFIG_VERSION";
//# sourceMappingURL=configConstants.js.map


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/dist/config/configConstants.js
// module id = 80
// module chunks = 0